import React from 'react';
import { FileText, Download } from 'lucide-react';
import { Section, Card } from '../shared/primitives';
import { labs, sendingSteps, typeAndScreen, rotem } from '../../../data/hospitals/thiLabs';

const Confirm = () => (
  <span className="inline-block ml-1.5 align-middle px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300">
    confirm
  </span>
);

const SendingLabs = () => (
  <div className="space-y-6">
    <Section title="Labs and tubes">
      <Card>
        {labs.map((t) => (
          <div key={t.test} className={`px-4 py-3 ${t.highlight ? 'bg-[#9F8D70]/10 dark:bg-[#9F8D70]/20' : ''}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-start gap-3 min-w-0">
                <span className="w-3.5 h-3.5 mt-1 rounded-full flex-shrink-0 ring-1 ring-black/10 dark:ring-white/10" style={{ backgroundColor: t.color }} aria-hidden="true" />
                <span className={`text-[15px] leading-snug ${t.highlight ? 'font-semibold text-[#6b5d48] dark:text-[#C4B5A0]' : 'text-gray-900 dark:text-white'}`}>{t.test}</span>
              </div>
              <span className="text-sm text-gray-600 dark:text-gray-300 text-right flex-shrink-0">
                {t.tube}{t.confirm && <Confirm />}
              </span>
            </div>
            {t.note && <p className="text-sm text-gray-600 dark:text-gray-300 mt-1 leading-snug pl-[1.625rem]">{t.note}</p>}
          </div>
        ))}
      </Card>
    </Section>

    <Section title="Sending a lab">
      <Card>
        {sendingSteps.map((step, i) => (
          <div key={step} className="px-4 py-3 flex gap-3">
            <span className="w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold flex-shrink-0" style={{ backgroundColor: 'rgba(159, 141, 112, 0.14)', color: '#8a7a61' }}>{i + 1}</span>
            <span className="text-[15px] text-gray-900 dark:text-white leading-snug pt-0.5">{step}</span>
          </div>
        ))}
      </Card>
    </Section>

    <Section title="Type and screen">
      <Card>
        <div className="px-4 py-3">
          <p className="text-[15px] text-gray-900 dark:text-white leading-snug">{typeAndScreen.text}</p>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">Write on the label{typeAndScreen.confirm && <Confirm />}</p>
          <ul className="mt-1 flex flex-wrap gap-1.5">
            {typeAndScreen.fields.map((f) => (
              <li key={f} className="px-2 py-0.5 rounded-md text-xs bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200">{f}</li>
            ))}
          </ul>
        </div>
      </Card>
    </Section>

    <Section title="ROTEM">
      <Card>
        <div className="px-4 py-3">
          <p className="text-[15px] text-gray-900 dark:text-white leading-snug">{rotem.text}</p>
          <p className="text-sm text-gray-400 dark:text-gray-500 italic mt-1">{rotem.pending}</p>
        </div>
        <a href={rotem.algorithm} target="_blank" rel="noopener noreferrer" className="px-4 py-3 flex items-center gap-3">
          <FileText size={18} className="text-[#9F8D70] flex-shrink-0" />
          <span className="flex-1 text-[15px] font-medium text-gray-900 dark:text-white">ROTEM-based transfusion algorithm</span>
          <Download size={16} className="text-gray-400" />
        </a>
      </Card>
    </Section>
  </div>
);

export default SendingLabs;
